import React, { useState } from "react";
import { Link } from "react-router-dom";

import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import { productCategories, productFAQ } from "../data/siteData";

const ALL_TAB = "All";
const TABS = [ALL_TAB, ...productCategories.map((c) => c.name)];

function Products() {
  const [activeTab, setActiveTab]   = useState(ALL_TAB);
  const [openFAQ,   setOpenFAQ]     = useState(null);

  const visibleCategories =
    activeTab === ALL_TAB
      ? productCategories
      : productCategories.filter((c) => c.name === activeTab);

  function toggleFAQ(index) {
    setOpenFAQ((prev) => (prev === index ? null : index));
  }

  return (
    <div className="page-shell">
      <SiteHeader />

      <main>

        {/* ── 1. PAGE HERO ────────────────────────────────────── */}
        <section className="page-hero products-hero">
          <div className="container">
            <nav className="breadcrumb" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span className="breadcrumb-sep">›</span>
              <span className="breadcrumb-current">Products</span>
            </nav>
            <p className="eyebrow">Product Catalogue</p>
            <h1>Our Products</h1>
            <p className="products-hero-sub">
              Generics · Branded Medicines · OTC · Parallel Imports · Consumables · Seasonal Lines
            </p>
          </div>
          <div className="products-hero-bg">
            <img
              src="https://images.unsplash.com/photo-1471864190281-a93a3070b6de?w=1600&auto=format&fit=crop"
              alt=""
              className="products-hero-img"
            />
            <div className="products-hero-overlay" />
          </div>
        </section>

        {/* ── 2. FILTER TABS ──────────────────────────────────── */}
        <div className="products-tabs-bar">
          <div className="container">
            <div className="products-tabs" role="tablist" aria-label="Product categories">
              {TABS.map((tab) => (
                <button
                  key={tab}
                  role="tab"
                  aria-selected={activeTab === tab}
                  className={`products-tab${activeTab === tab ? " active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* ── 3. CATEGORY CARDS GRID ──────────────────────────── */}
        <section className="section" style={{ background: "var(--off-white)" }}>
          <div className="container">

            {activeTab === ALL_TAB && (
              <div className="section-heading">
                <p className="eyebrow">Full Catalogue</p>
                <h2>All product categories.</h2>
                <p>
                  Our portfolio is structured across six categories to help
                  procurement teams find and confirm supply options quickly.
                </p>
              </div>
            )}

            {activeTab !== ALL_TAB && (
              <div className="section-heading">
                <p className="eyebrow">Category</p>
                <h2>{activeTab}</h2>
              </div>
            )}

            <div className="products-grid">
              {visibleCategories.map((cat) => (
                <article key={cat.id} className="products-category-card">
                  <div className="products-card-top">
                    <span className="tag">{cat.tag}</span>
                    <h3>{cat.name}</h3>
                    <p>{cat.description}</p>
                  </div>
                  <div className="products-card-items">
                    <p className="products-card-items-label">Includes</p>
                    <ul className="category-items">
                      {cat.items.map((item) => (
                        <li key={item} className="category-item">{item}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="products-card-footer">
                    <Link to="/contact" className="btn btn-ghost products-card-cta">
                      Enquire about this category →
                    </Link>
                  </div>
                </article>
              ))}
            </div>

          </div>
        </section>

        {/* ── 4. FAQ ACCORDION ────────────────────────────────── */}
        <section className="section" style={{ background: "var(--white)" }}>
          <div className="container">
            <div className="section-heading centered">
              <p className="eyebrow">Common Questions</p>
              <h2>Frequently asked by trade buyers.</h2>
            </div>

            <div className="products-faq">
              {productFAQ.map((item, i) => (
                <div
                  key={i}
                  className={`faq-item${openFAQ === i ? " open" : ""}`}
                >
                  <button
                    className="faq-question"
                    onClick={() => toggleFAQ(i)}
                    aria-expanded={openFAQ === i}
                  >
                    {item.q}
                    <span className="faq-icon" aria-hidden="true">+</span>
                  </button>
                  <p className="faq-answer">{item.a}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── 5. CTA ──────────────────────────────────────────── */}
        <section className="section section-dark">
          <div className="container products-cta-grid">
            <div className="products-cta-copy">
              <p className="eyebrow">Can't find what you need?</p>
              <h2>We can source it for you.</h2>
              <p>
                Our parallel import and sourcing capability means we can often
                fulfil requests outside our standard catalogue. Send us your
                product list and we will confirm availability within 24 hours.
              </p>
              <div className="btn-group" style={{ marginTop: "2rem" }}>
                <Link to="/contact" className="btn btn-primary">
                  Contact our team
                </Link>
                <Link to="/services" className="btn btn-outline">
                  View our services →
                </Link>
              </div>
            </div>
            <div className="products-cta-image-wrap">
              <img
                src="https://images.unsplash.com/photo-1563213126-a4273aed2016?w=1200&auto=format&fit=crop"
                alt="Medicine supply"
                className="products-cta-image"
              />
            </div>
          </div>
        </section>

      </main>

      <SiteFooter />
    </div>
  );
}

export default Products;
